/*
 * @Author: flyer
 * @Date: 2021-04-12 15:55:41
 * @LastEditTime: 2022-01-12 17:39:29
 * @LastEditors: jieyang
 * @Description: api的拦截器
 */

import { LOGOUT } from "@/auth";
import store from "@/store";
import { Message } from "element-ui";
import { setRequestHeader } from "./epas-auth";

function getAuthExpries() {
  const timestamp = new Date().getTime() + 20 * 60 * 1000;
  return timestamp;
}

function getAuthorization(appKey, appSecret, url, timestamp) {
  const signToString = `${url}\n${timestamp}`;
  // eslint-disable-next-line no-undef
  const sha1Value = CryptoJS.HmacSHA1(signToString, appSecret);
  // eslint-disable-next-line no-undef
  const base64Value = CryptoJS.enc.Base64.stringify(sha1Value);
  const signature = base64Value
    .replace(new RegExp("/", "gm"), "_")
    .replace(new RegExp("\\+", "gm"), "-");
  /* alert(`signToString=${signToString};sha1Value=${sha1Value};base64Value=${base64Value};signature=${signature}`) */
  const authorization = "OPC " + appKey + ":" + signature;
  return authorization;
}

export const requestInterceptor = (config) => {
  const userInfo = store.state.user.userInfo;
  if (config.data) {
    config.data["projectId"] = userInfo.projectId;
    config.data["userId"] = userInfo.userId;
  }
  config.headers["S-Auth-Token"] = localStorage.getItem("opc-token") || "";
  if (config.data && Object.keys(config.data).includes("isNotMessage")) {
    config.isNotMessage = config.data.isNotMessage;
    delete config.data.isNotMessage;
  }
  setRequestHeader(config);
  return config;
};
export const responseData = (res) => {
  const { data, status } = res;
  if (
    data.code === "200" ||
    data.code === 200 ||
    data.code === "1" ||
    data.code === 1
  ) {
    return data;
  } else {
    if (String(data.code) === "-1002" || data.code === "403") {
      LOGOUT();
      return;
    }
    if (!res.config.isNotMessage) {
      Message.error(data.message);
    }
    return Promise.reject(data);
  }
};

export const responseError = (error) => {
  if (error.response) {
    return Promise.reject(error.response);
  } else {
    return Promise.reject(error);
  }
};
